module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/otwarcie/big/3-8e3f2a14ffc419f8688cdfd671d7eb89.webp";